import ContactForm from '@/components/sections/ContactForm'
import DoubleImg from '@/components/sections/DoubleImg'
import DoubleParagraph from '@/components/sections/DoubleParagraph'
import DoubleRibbonPictures from '@/components/sections/DoubleRibbonPictures'
import FreeText from '@/components/sections/FreeText'
import GalleryDownload from '@/components/sections/GalleryDownload'
import HeroResize from '@/components/sections/HeroResize'
import ImageParagraph from '@/components/sections/ImageParagraph'
import KaraokeText from '@/components/sections/KaraokeText'
import ProductParagraph from '@/components/sections/ProductParagraph'
import ProjectsBlock from '@/components/sections/ProjectsBlock'
import RibbonPictures from '@/components/sections/RibbonPictures'
import ScrollImg from '@/components/sections/ScrollImg'
import SimpleParagraph from '@/components/sections/SimpleParagraph'
import SimpleText from '@/components/sections/SimpleText'
import SingleImg from '@/components/sections/SingleImg'
import Spacer from '@/components/sections/Spacer'
import Team from '@/components/sections/Team'
import TextOnImage from '@/components/sections/TextOnImage'
import VerticalImageParagraph from '@/components/sections/VerticalImageParagraph'

export const sectionsMap: any = {
  double_img: DoubleImg,
  double_paragraph: DoubleParagraph,
  double_ribbon_pictures: DoubleRibbonPictures,
  gallery_download: GalleryDownload,
  image_paragraph: ImageParagraph,
  vertical_image_paragraph: VerticalImageParagraph,
  free_text: FreeText,
  karaoke_text: KaraokeText,
  product_paragraph: ProductParagraph,
  projects_block: ProjectsBlock,
  hero_resize: HeroResize,
  ribbon_pictures: RibbonPictures,
  scroll_img: ScrollImg,
  simple_paragraph: SimpleParagraph,
  simple_text: SimpleText,
  single_img: SingleImg,
  spacer: Spacer,
  team: Team,
  text_on_image: TextOnImage,
  form: ContactForm
}
